import React from 'react';
import CustomDialog from '../../reusable/CustomDialog';
import { delEvent } from '../../../utils/ApiFunctions';

function Deletepopup({open,handleClose,id}) {

  const deleteHandler=async()=>{
    const resp=await delEvent(id);
    if(resp){
      window.location.reload();
    }
  }
    return (
        <>
        
        <CustomDialog
        open={open}
        handleClose={handleClose}
        title={"Delete"}
        maincontent={"Are you sure you want to delete this event?"}
        subcontent={"You are about to delete this event. This won't stay in employee database any longer."}
        btnOne={"Delete"}
        btnTwo={"Cancel"}
        btnOneClick={deleteHandler}
      />
        
        </>
    );
}

export default Deletepopup;